import { render, staticRenderFns } from "./VolunteerStatusSwitch.vue?vue&type=template&id=f5f41562&scoped=true&"
import script from "./VolunteerStatusSwitch.vue?vue&type=script&lang=js&"
export * from "./VolunteerStatusSwitch.vue?vue&type=script&lang=js&"
import style0 from "./VolunteerStatusSwitch.vue?vue&type=style&index=0&id=f5f41562&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5f41562",
  null
  
)

export default component.exports